import { SessionLayer } from "../../interfaces";
import { getAppBFFUrl } from "../functions";
import { formatData, handleError, handleStepSuccessEvent } from "./api";

export const sendDataToBuffer = async (data: SessionLayer, requestConditions: any) => {
  const { lead_data, push_data, marketing_data } = data;
  const { is_last_step, hasSuccessStep, defaultSuccessPageUrl, successPageRules, stepHasEmailField, stepHasPhoneField } = requestConditions;
  const formCompleted = is_last_step || hasSuccessStep;
  const formattedData = await formatData(lead_data, push_data, marketing_data, formCompleted);
  const baseUrl = await getAppBFFUrl();

  const leadDataObject: Record<string, FormDataEntryValue> = {};
  const requestBody = new FormData();
  formattedData.forEach((value: FormDataEntryValue, key: string) => {
    if(key === "prescription" || key === "id_" || key === "is_last_step") {
      requestBody.append(key, value);
    } else {
      leadDataObject[key] = value;
    }
  });

  leadDataObject["form_completion"] = formCompleted ? "completed" : "partial";
  leadDataObject["json_data_string"] = JSON.stringify(leadDataObject);

  if (formCompleted) {
    const cleanLeadDataObject = { ...leadDataObject };
    delete cleanLeadDataObject.json_data_string;
    if (requestBody.has("prescription")) {
      cleanLeadDataObject.prescription = "prescription";
    }
  }

  const leadDataString = JSON.stringify(leadDataObject);
  requestBody.append("data", leadDataString);

  try {
    const res = await fetch(
      `${baseUrl}/platform-nexus/public/v2/buffer/`,
      {
        method: 'POST',
        body: requestBody,
      },
    );
    await handleStepSuccessEvent(res, is_last_step, hasSuccessStep, defaultSuccessPageUrl, successPageRules, stepHasEmailField, stepHasPhoneField);

    const jsonData = await res.json();
    if(jsonData && !is_last_step) window.sessionLayer.lead.id_ = jsonData.id_;

    return {res, details: jsonData?.detail}
  } catch (error) {
    handleError(error);
  }
}